
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software-development",
      function () {
        return require("private-next-pages/software-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software-development"])
      });
    }
  